import styled from "styled-components";

export const UploadSectionWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: 32px 20px 0px 20px;
`